import { css } from '@emotion/css';

export const canvas = css`
  label: interaction-canvas;
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
`;
